import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { whiteColor } from 'src/constants';

export const useStyles = makeStyles(() => createStyles({
  assignContainer: (getGridsWidth: (width: number) => number) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: `${getGridsWidth(2)}px`,
    '& .toggle-group': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '4px',
      borderRadius: '8px',
      backgroundColor: 'rgba(30, 30, 30, 0.10)',
    },
    '& .btn': {
      width: '100%',
      padding: '8px 0',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px',
      background: whiteColor,
      color: '#1E1E1E',
    },
    '& .btn.active': {
      background: '#1E1E1E',
      color: whiteColor,
    },
  }),
}));
